<!-- ============================================================
     PAGE HERO
============================================================ -->
            <div class="hero-header">
          <app-header-latest></app-header-latest>
      </div>
<div class="page-hero-feat"   style="background-image:url('assets/images/banner/Emp-contact-us.jpg');    background-repeat: no-repeat;background-size: cover;padding-bottom: 40px;">
  <div class="page-hero-feat__bg"></div>
  <div class="con-wrapper" style="position:relative;z-index:2;">
    <div class="section-eyebrow" style="margin:0 auto 18px;display:table;">✦ Platform Features</div>
    <h1 class="page-hero-feat__h1">
      Every Feature Your<br><span class="gra-text">HR Team Needs</span>
    </h1>
    <p class="page-hero-feat__sub">
      From day-one onboarding to year-end appraisals — NeoHRMZ automates every HR workflow so you can focus on people, not paperwork.
    </p>
    <div style="display:flex;align-items:center;justify-content:center;gap:14px;flex-wrap:wrap;">
      <a href="#" class="btn btn-primary btn-lg">Start Free Trial</a>
      <a href="#" class="btn btn-outline btn-lg">▶ Watch Product Tour</a>
    </div>
  </div>
</div>


<!-- ============================================================
     FEATURE DETAIL ROWS
============================================================ -->
<div class="container-wrapper">

  <!-- ── 1. Employee Management ──────────────────────────────── -->
  <div class="feat-detail-row">
    <div class="feat-detail__copy">
      <div class="feat-detail__tag">👥 Core HR</div>
      <h2 class="feat-detail__h2">Employee Management,<br>Done Right</h2>
      <p class="feat-detail__p">A single source of truth for every employee — from hire to retire. Manage profiles, documents, org charts, and employment history with zero complexity.</p>
      <div class="feat-detail__points">
        <div class="feat-point"><div class="feat-point__ico">✓</div> Rich employee profiles with custom fields & documents</div>
        <div class="feat-point"><div class="feat-point__ico">✓</div> Dynamic org charts with drag-and-drop hierarchy</div>
        <div class="feat-point"><div class="feat-point__ico">✓</div> Role-based access control — HR, managers, employees</div>
        <div class="feat-point"><div class="feat-point__ico">✓</div> Full employment history & audit trail</div>
        <div class="feat-point"><div class="feat-point__ico">✓</div> Bulk import from Excel, Google Sheets, or HRMS</div>
      </div>
      <a href="employee-management.html" class="btn btn-primary">Explore Employee Module →</a>
    </div>
    <div class="feat-detail__visual">
      <div class="feat-mock">
        <div class="mock-header">
          <span class="mock-title">👥 Employee Directory</span>
          <div class="mock-dots">
            <div class="mock-dot" style="background:#f87171;"></div>
            <div class="mock-dot" style="background:#fbbf24;"></div>
            <div class="mock-dot" style="background:#4ade80;"></div>
          </div>
        </div>
        <div class="mock-row">
          <div class="mock-avatar">AK</div>
          <div style="flex:1;">
            <div class="mock-name">Alex Kumar</div>
            <div class="mock-dept">Engineering · Senior Dev</div>
          </div>
          <div class="mock-pill green">Active</div>
        </div>
        <div class="mock-row">
          <div class="mock-avatar" style="background:linear-gradient(135deg,#7F00FF,#6900D1);">PS</div>
          <div style="flex:1;">
            <div class="mock-name">Priya Sharma</div>
            <div class="mock-dept">Design · UI Lead</div>
          </div>
          <div class="mock-pill green">Active</div>
        </div>
        <div class="mock-row">
          <div class="mock-avatar" style="background:linear-gradient(135deg,#6900D1,#5200A3);">RJ</div>
          <div style="flex:1;">
            <div class="mock-name">Rahul Jain</div>
            <div class="mock-dept">Sales · Account Exec</div>
          </div>
          <div class="mock-pill yellow">On Leave</div>
        </div>
        <div class="mock-row">
          <div class="mock-avatar" style="background:linear-gradient(135deg,#5200A3,#3B0075);">NK</div>
          <div style="flex:1;">
            <div class="mock-name">Nisha Khan</div>
            <div class="mock-dept">HR · Talent Manager</div>
          </div>
          <div class="mock-pill green">Active</div>
        </div>
        <div class="mock-row">
          <div class="mock-avatar" style="background:linear-gradient(135deg,#7F00FF,#5200A3);">DM</div>
          <div style="flex:1;">
            <div class="mock-name">Dev Mehra</div>
            <div class="mock-dept">Finance · Analyst</div>
          </div>
          <div class="mock-pill blue">Remote</div>
        </div>
        <div style="margin-top:14px;padding-top:14px;border-top:1px solid var(--border);display:flex;gap:8px;">
          <div style="flex:1;text-align:center;background:var(--bg-alt);border:1px solid var(--border);border-radius:8px;padding:10px;">
            <div style="font-size:20px;font-weight:800;color:var(--text);">1,248</div>
            <div style="font-size:10px;color:var(--text-muted);margin-top:2px;">Total</div>
          </div>
          <div style="flex:1;text-align:center;background:#ECFDF5;border:1px solid #D1FAE5;border-radius:8px;padding:10px;">
            <div style="font-size:20px;font-weight:800;color:#059669;">1,182</div>
            <div style="font-size:10px;color:var(--text-muted);margin-top:2px;">Active</div>
          </div>
          <div style="flex:1;text-align:center;background:#FFFBEB;border:1px solid #FDE68A;border-radius:8px;padding:10px;">
            <div style="font-size:20px;font-weight:800;color:#D97706;">66</div>
            <div style="font-size:10px;color:var(--text-muted);margin-top:2px;">On Leave</div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <!-- ── 2. Payroll ──────────────────────────────────────────── -->
  <div class="feat-detail-row reverse">
    <div class="feat-detail__copy">
      <div class="feat-detail__tag">💰 Payroll</div>
      <h2 class="feat-detail__h2">Payroll in Minutes,<br>Not Days</h2>
      <p class="feat-detail__p">Run payroll for your entire company in a few clicks. Automate tax calculations, deductions, reimbursements, and compliance filings without a single spreadsheet.</p>
      <div class="feat-detail__points">
        <div class="feat-point"><div class="feat-point__ico">✓</div> One-click payroll processing for any team size</div>
        <div class="feat-point"><div class="feat-point__ico">✓</div> Auto tax computation — TDS, PF, ESI, PT & more</div>
        <div class="feat-point"><div class="feat-point__ico">✓</div> Digital payslips delivered to employee inboxes</div>
        <div class="feat-point"><div class="feat-point__ico">✓</div> Multi-currency & multi-entity support</div>
        <div class="feat-point"><div class="feat-point__ico">✓</div> Bank transfer integration — NEFT, IMPS, ACH</div>
      </div>
      <a href="payroll.html" class="btn btn-primary">Explore Payroll Module →</a>
    </div>
    <div class="feat-detail__visual">
      <div class="feat-mock">
        <div class="mock-header">
          <span class="mock-title">💰 Payroll Summary — Nov 2025</span>
          <div class="mock-pill green" style="font-size:11px;">Processed</div>
        </div>
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:16px;">
          <div style="background:var(--bg-alt);border:1px solid var(--border);border-radius:10px;padding:14px;">
            <div style="font-size:11px;color:var(--text-muted);margin-bottom:4px;">Gross Payroll</div>
            <div style="font-size:22px;font-weight:800;color:var(--text);">$2,418,400</div>
          </div>
          <div style="background:#ECFDF5;border:1px solid #D1FAE5;border-radius:10px;padding:14px;">
            <div style="font-size:11px;color:var(--text-muted);margin-bottom:4px;">Net Disbursed</div>
            <div style="font-size:22px;font-weight:800;color:#059669;">$2,094,300</div>
          </div>
          <div style="background:#FFFBEB;border:1px solid #FDE68A;border-radius:10px;padding:14px;">
            <div style="font-size:11px;color:var(--text-muted);margin-bottom:4px;">Tax Deducted</div>
            <div style="font-size:22px;font-weight:800;color:#D97706;">$218,200</div>
          </div>
          <div style="background:#EFF6FF;border:1px solid #BFDBFE;border-radius:10px;padding:14px;">
            <div style="font-size:11px;color:var(--text-muted);margin-bottom:4px;">Employees Paid</div>
            <div style="font-size:22px;font-weight:800;color:#2563EB;">1,248</div>
          </div>
        </div>
        <div style="font-size:11px;color:var(--text-muted);text-transform:uppercase;letter-spacing:0.8px;margin-bottom:8px;">Deduction Breakdown</div>
        <div class="mock-progress">
          <div class="mock-prog-row">
            <div class="mock-prog-label">TDS / Income Tax</div>
            <div class="mock-prog-bar"><div class="mock-prog-fill" style="width:55%;"></div></div>
            <div class="mock-prog-val">55%</div>
          </div>
          <div class="mock-prog-row">
            <div class="mock-prog-label">PF Employee</div>
            <div class="mock-prog-bar"><div class="mock-prog-fill" style="width:28%;background:linear-gradient(90deg,#059669,#10b981);"></div></div>
            <div class="mock-prog-val">28%</div>
          </div>
          <div class="mock-prog-row">
            <div class="mock-prog-label">ESI</div>
            <div class="mock-prog-bar"><div class="mock-prog-fill" style="width:10%;background:linear-gradient(90deg,#D97706,#F59E0B);"></div></div>
            <div class="mock-prog-val">10%</div>
          </div>
          <div class="mock-prog-row">
            <div class="mock-prog-label">Prof. Tax</div>
            <div class="mock-prog-bar"><div class="mock-prog-fill" style="width:7%;background:linear-gradient(90deg,#2563EB,#3B82F6);"></div></div>
            <div class="mock-prog-val">7%</div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <!-- ── 3. Attendance ──────────────────────────────────────── -->
  <div class="feat-detail-row">
    <div class="feat-detail__copy">
      <div class="feat-detail__tag">📅 Attendance</div>
      <h2 class="feat-detail__h2">Attendance Tracking<br>Without the Hassle</h2>
      <p class="feat-detail__p">Whether your team is remote, hybrid, or in-office — NeoHRMZ tracks attendance in real time with biometric integrations, geo-fencing, and smart shift management.</p>
      <div class="feat-detail__points">
        <div class="feat-point"><div class="feat-point__ico">✓</div> Web, mobile & biometric clock-in/out</div>
        <div class="feat-point"><div class="feat-point__ico">✓</div> Geo-fencing for field teams</div>
        <div class="feat-point"><div class="feat-point__ico">✓</div> Flexible shift planning & swap requests</div>
        <div class="feat-point"><div class="feat-point__ico">✓</div> Overtime & comp-off auto calculation</div>
        <div class="feat-point"><div class="feat-point__ico">✓</div> Real-time attendance dashboard for managers</div>
      </div>
      <a href="attendance.html" class="btn btn-primary">Explore Attendance Module →</a>
    </div>
    <div class="feat-detail__visual">
      <div class="feat-mock">
        <div class="mock-header">
          <span class="mock-title">📅 Today's Attendance</span>
          <div style="font-size:11px;color:var(--text-muted);">Mon, 25 Nov 2025</div>
        </div>
        <div style="display:flex;gap:10px;margin-bottom:16px;">
          <div style="flex:1;text-align:center;background:#ECFDF5;border:1px solid #D1FAE5;border-radius:10px;padding:12px;">
            <div style="font-size:24px;font-weight:800;color:#059669;">1,134</div>
            <div style="font-size:10px;color:var(--text-muted);">Present</div>
          </div>
          <div style="flex:1;text-align:center;background:#FFFBEB;border:1px solid #FDE68A;border-radius:10px;padding:12px;">
            <div style="font-size:24px;font-weight:800;color:#D97706;">66</div>
            <div style="font-size:10px;color:var(--text-muted);">On Leave</div>
          </div>
          <div style="flex:1;text-align:center;background:#FEF2F2;border:1px solid #FECACA;border-radius:10px;padding:12px;">
            <div style="font-size:24px;font-weight:800;color:#DC2626;">48</div>
            <div style="font-size:10px;color:var(--text-muted);">Late</div>
          </div>
        </div>
        <div style="font-size:11px;color:var(--text-muted);text-transform:uppercase;letter-spacing:0.8px;margin-bottom:8px;">Department Attendance Rate</div>
        <div class="mock-progress">
          <div class="mock-prog-row">
            <div class="mock-prog-label">Engineering</div>
            <div class="mock-prog-bar"><div class="mock-prog-fill" style="width:97%;"></div></div>
            <div class="mock-prog-val">97%</div>
          </div>
          <div class="mock-prog-row">
            <div class="mock-prog-label">Sales</div>
            <div class="mock-prog-bar"><div class="mock-prog-fill" style="width:93%;"></div></div>
            <div class="mock-prog-val">93%</div>
          </div>
          <div class="mock-prog-row">
            <div class="mock-prog-label">Design</div>
            <div class="mock-prog-bar"><div class="mock-prog-fill" style="width:100%;"></div></div>
            <div class="mock-prog-val">100%</div>
          </div>
          <div class="mock-prog-row">
            <div class="mock-prog-label">Finance</div>
            <div class="mock-prog-bar"><div class="mock-prog-fill" style="width:88%;background:linear-gradient(90deg,#D97706,#F59E0B);"></div></div>
            <div class="mock-prog-val">88%</div>
          </div>
          <div class="mock-prog-row">
            <div class="mock-prog-label">Operations</div>
            <div class="mock-prog-bar"><div class="mock-prog-fill" style="width:91%;"></div></div>
            <div class="mock-prog-val">91%</div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <!-- ── 4. Performance ────────────────────────────────────── -->
  <div class="feat-detail-row reverse">
    <div class="feat-detail__copy">
      <div class="feat-detail__tag">📈 Performance</div>
      <h2 class="feat-detail__h2">Build a<br>High-Performance Culture</h2>
      <p class="feat-detail__p">Move beyond annual reviews. Set clear goals, gather continuous feedback, and surface AI insights that help every manager and employee grow.</p>
      <div class="feat-detail__points">
        <div class="feat-point"><div class="feat-point__ico">✓</div> OKR framework with cascading goals</div>
        <div class="feat-point"><div class="feat-point__ico">✓</div> 360° reviews — peers, managers, self</div>
        <div class="feat-point"><div class="feat-point__ico">✓</div> Continuous check-ins & pulse surveys</div>
        <div class="feat-point"><div class="feat-point__ico">✓</div> AI-generated performance summaries</div>
        <div class="feat-point"><div class="feat-point__ico">✓</div> Calibration matrix for stack ranking</div>
      </div>
      <a href="performance.html" class="btn btn-primary">Explore Performance Module →</a>
    </div>
    <div class="feat-detail__visual">
      <div class="feat-mock">
        <div class="mock-header">
          <span class="mock-title">📈 Q4 Performance Cycle</span>
          <div class="mock-pill blue">In Progress</div>
        </div>
        <div style="margin-bottom:16px;">
          <div style="font-size:11px;color:var(--text-muted);text-transform:uppercase;letter-spacing:0.8px;margin-bottom:10px;">Review Completion</div>
          <div class="mock-progress">
            <div class="mock-prog-row">
              <div class="mock-prog-label">Self Review</div>
              <div class="mock-prog-bar"><div class="mock-prog-fill" style="width:84%;"></div></div>
              <div class="mock-prog-val">84%</div>
            </div>
            <div class="mock-prog-row">
              <div class="mock-prog-label">Peer Review</div>
              <div class="mock-prog-bar"><div class="mock-prog-fill" style="width:62%;background:linear-gradient(90deg,#2563EB,#3B82F6);"></div></div>
              <div class="mock-prog-val">62%</div>
            </div>
            <div class="mock-prog-row">
              <div class="mock-prog-label">Manager Review</div>
              <div class="mock-prog-bar"><div class="mock-prog-fill" style="width:45%;background:linear-gradient(90deg,#D97706,#F59E0B);"></div></div>
              <div class="mock-prog-val">45%</div>
            </div>
          </div>
        </div>
        <div style="font-size:11px;color:var(--text-muted);text-transform:uppercase;letter-spacing:0.8px;margin-bottom:10px;">Rating Distribution</div>
        <div class="mock-chart">
          <div class="mock-cbar dim" style="height:30%;"></div>
          <div class="mock-cbar" style="height:60%;"></div>
          <div class="mock-cbar highlight" style="height:100%;"></div>
          <div class="mock-cbar" style="height:75%;"></div>
          <div class="mock-cbar dim" style="height:40%;"></div>
        </div>
        <div style="display:flex;justify-content:space-between;font-size:10px;color:var(--text-muted);margin-top:4px;">
          <span>Below Exp</span><span>Meets</span><span>Exceeds</span><span>Exceptional</span><span>Top Perf</span>
        </div>
      </div>
    </div>
  </div>


  <!-- ── 5. Recruitment ────────────────────────────────────── -->
  <div class="feat-detail-row">
    <div class="feat-detail__copy">
      <div class="feat-detail__tag">🎯 Recruitment</div>
      <h2 class="feat-detail__h2">Hire the Best,<br>Faster Than Ever</h2>
      <p class="feat-detail__p">A complete ATS built into your HRMS. Post jobs, screen applicants with AI, schedule interviews, and convert offers to onboarding — all without switching tabs.</p>
      <div class="feat-detail__points">
        <div class="feat-point"><div class="feat-point__ico">✓</div> One-click job posting to 15+ job boards</div>
        <div class="feat-point"><div class="feat-point__ico">✓</div> AI resume screening & candidate scoring</div>
        <div class="feat-point"><div class="feat-point__ico">✓</div> Collaborative interview scorecards</div>
        <div class="feat-point"><div class="feat-point__ico">✓</div> Offer letter generation & e-signature</div>
        <div class="feat-point"><div class="feat-point__ico">✓</div> Auto-convert hired candidates to employees</div>
      </div>
      <a href="recruitment.html" class="btn btn-primary">Explore Recruitment Module →</a>
    </div>
    <div class="feat-detail__visual">
      <div class="feat-mock">
        <div class="mock-header">
          <span class="mock-title">🎯 Open Roles Pipeline</span>
          <div style="font-size:11px;color:var(--text-muted);">34 Active Positions</div>
        </div>
        <div style="display:flex;flex-direction:column;gap:10px;">
          <div style="background:var(--bg-alt);border:1px solid var(--border);border-radius:10px;padding:12px;">
            <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:8px;">
              <div style="font-size:13px;font-weight:700;color:var(--text);">Senior Frontend Engineer</div>
              <div class="mock-pill green">Active</div>
            </div>
            <div style="display:flex;gap:8px;font-size:11px;color:var(--text-muted);">
              <span>📍 Remote</span><span>·</span><span>👥 142 Applied</span><span>·</span><span>🔍 23 Shortlisted</span>
            </div>
          </div>
          <div style="background:var(--bg-alt);border:1px solid var(--border);border-radius:10px;padding:12px;">
            <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:8px;">
              <div style="font-size:13px;font-weight:700;color:var(--text);">Product Designer</div>
              <div class="mock-pill blue">Interviewing</div>
            </div>
            <div style="display:flex;gap:8px;font-size:11px;color:var(--text-muted);">
              <span>📍 Bangalore</span><span>·</span><span>👥 87 Applied</span><span>·</span><span>🔍 8 Shortlisted</span>
            </div>
          </div>
          <div style="background:var(--bg-alt);border:1px solid var(--border);border-radius:10px;padding:12px;">
            <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:8px;">
              <div style="font-size:13px;font-weight:700;color:var(--text);">Sales Manager — APAC</div>
              <div class="mock-pill yellow">Offer Stage</div>
            </div>
            <div style="display:flex;gap:8px;font-size:11px;color:var(--text-muted);">
              <span>📍 Singapore</span><span>·</span><span>👥 55 Applied</span><span>·</span><span>🔍 3 Final</span>
            </div>
          </div>
        </div>
        <div style="margin-top:12px;font-size:11px;color:var(--text-muted);text-align:center;">+ 31 more open positions</div>
      </div>
    </div>
  </div>


  <!-- ── 6. AI Assistant ───────────────────────────────────── -->
  <div class="feat-detail-row reverse" style="border-bottom:none;">
    <div class="feat-detail__copy">
      <div class="feat-detail__tag" style="background:#FFFBEB;border-color:#FDE68A;color:#D97706;">🤖 AI Tools — Beta</div>
      <h2 class="feat-detail__h2">Meet Your AI<br>HR Co-Pilot</h2>
      <p class="feat-detail__p">Answer employee questions instantly, generate reports on demand, draft job descriptions, and get predictive alerts before issues arise — powered by our built-in AI.</p>
      <div class="feat-detail__points">
        <div class="feat-point"><div class="feat-point__ico">✓</div> Natural language answers to HR policy questions</div>
        <div class="feat-point"><div class="feat-point__ico">✓</div> Auto-generated performance review summaries</div>
        <div class="feat-point"><div class="feat-point__ico">✓</div> Attrition risk prediction with early alerts</div>
        <div class="feat-point"><div class="feat-point__ico">✓</div> Smart leave & attendance anomaly detection</div>
        <div class="feat-point"><div class="feat-point__ico">✓</div> JD generator & candidate fit scoring</div>
      </div>
      <a href="ai-assistant.html" class="btn btn-primary">Try AI Assistant →</a>
    </div>
    <div class="feat-detail__visual">
      <div class="feat-mock">
        <div class="mock-header">
          <span class="mock-title">🤖 NeoHRMZ AI</span>
          <div class="mock-pill yellow">Beta</div>
        </div>
        <div style="display:flex;flex-direction:column;gap:10px;">
          <!-- User bubble -->
          <div style="background:var(--p100);border-radius:12px 12px 12px 2px;padding:12px 14px;max-width:85%;">
            <div style="font-size:12px;color:var(--text-muted);margin-bottom:4px;">You</div>
            <div style="font-size:13px;color:var(--text);">How many leave days does Priya Sharma have remaining this year?</div>
          </div>
          <!-- AI bubble -->
          <div style="background:#fff;border:1px solid var(--border-hi);border-radius:12px 12px 2px 12px;padding:12px 14px;align-self:flex-end;max-width:90%;">
            <div style="font-size:12px;color:var(--p600);font-weight:700;margin-bottom:4px;">NeoHRMZ AI ✦</div>
            <div style="font-size:13px;color:var(--text-sub);line-height:1.6;">Priya Sharma (Design · UI Lead) has <strong style="color:#059669;">8 Casual Leaves</strong> and <strong style="color:#2563EB;">6 Sick Leaves</strong> remaining as of today. She has a pending leave request for 26–27 Nov (2 days) awaiting approval.</div>
          </div>
          <!-- User bubble -->
          <div style="background:var(--p100);border-radius:12px 12px 12px 2px;padding:12px 14px;max-width:75%;">
            <div style="font-size:12px;color:var(--text-muted);margin-bottom:4px;">You</div>
            <div style="font-size:13px;color:var(--text);">Generate payroll summary for November 2025</div>
          </div>
          <!-- AI bubble -->
          <div style="background:#fff;border:1px solid var(--border-hi);border-radius:12px 12px 2px 12px;padding:12px 14px;align-self:flex-end;">
            <div style="font-size:12px;color:var(--p600);font-weight:700;margin-bottom:6px;">NeoHRMZ AI ✦</div>
            <div style="font-size:13px;color:var(--text-sub);">✅ November payroll summary generated for <strong style="color:var(--text);">1,248 employees</strong>. Total gross: <strong style="color:#059669;">$2,418,400</strong>. Sending PDF to your inbox.</div>
          </div>
        </div>
        <!-- Input bar -->
        <div style="margin-top:14px;background:var(--bg-alt);border:1px solid var(--border);border-radius:10px;padding:10px 14px;display:flex;align-items:center;gap:10px;">
          <span style="font-size:13px;color:var(--text-muted);flex:1;">Ask anything about your HR data…</span>
          <div style="width:28px;height:28px;background:linear-gradient(135deg,var(--p500),var(--p600));border-radius:8px;display:flex;align-items:center;justify-content:center;font-size:13px;color:#fff;cursor:pointer;">↑</div>
        </div>
      </div>
    </div>
  </div>

</div><!-- /.container -->


<!-- ============================================================
     ALL FEATURES GRID
============================================================ -->
<section style="background:var(--bg-alt);">
  <div class="container-wrapper">
    <div class="sec-head">
      <div class="section-eyebrow">📋 Full Feature List</div>
      <h2 class="sec-h2">Everything<br><span class="gradient-text">Included</span></h2>
      <p class="sec-sub">Every plan includes the complete feature set. No à-la-carte pricing, no surprise add-ons.</p>
    </div>

    <div style="display:grid;grid-template-columns:repeat(3,1fr);gap:16px;">

      <div style="background:#fff;border:1px solid var(--border);border-radius:16px;padding:24px;box-shadow:var(--shadow-sm);">
        <div style="font-size:22px;margin-bottom:12px;">👥</div>
        <div style="font-size:15px;font-weight:700;color:var(--text);margin-bottom:10px;">Core HR</div>
        <div style="display:flex;flex-direction:column;gap:8px;">
          <div style="font-size:13px;color:var(--text-sub);display:flex;align-items:center;gap:7px;"><span style="color:#059669;font-size:11px;">✓</span> Employee profiles & custom fields</div>
          <div style="font-size:13px;color:var(--text-sub);display:flex;align-items:center;gap:7px;"><span style="color:#059669;font-size:11px;">✓</span> Org chart & hierarchy</div>
          <div style="font-size:13px;color:var(--text-sub);display:flex;align-items:center;gap:7px;"><span style="color:#059669;font-size:11px;">✓</span> Document management</div>
          <div style="font-size:13px;color:var(--text-sub);display:flex;align-items:center;gap:7px;"><span style="color:#059669;font-size:11px;">✓</span> Onboarding workflows</div>
          <div style="font-size:13px;color:var(--text-sub);display:flex;align-items:center;gap:7px;"><span style="color:#059669;font-size:11px;">✓</span> Offboarding checklists</div>
        </div>
      </div>

      <div style="background:#fff;border:1px solid var(--border);border-radius:16px;padding:24px;box-shadow:var(--shadow-sm);">
        <div style="font-size:22px;margin-bottom:12px;">💰</div>
        <div style="font-size:15px;font-weight:700;color:var(--text);margin-bottom:10px;">Payroll & Finance</div>
        <div style="display:flex;flex-direction:column;gap:8px;">
          <div style="font-size:13px;color:var(--text-sub);display:flex;align-items:center;gap:7px;"><span style="color:#059669;font-size:11px;">✓</span> Automated payroll runs</div>
          <div style="font-size:13px;color:var(--text-sub);display:flex;align-items:center;gap:7px;"><span style="color:#059669;font-size:11px;">✓</span> Tax & compliance filing</div>
          <div style="font-size:13px;color:var(--text-sub);display:flex;align-items:center;gap:7px;"><span style="color:#059669;font-size:11px;">✓</span> Expense reimbursements</div>
          <div style="font-size:13px;color:var(--text-sub);display:flex;align-items:center;gap:7px;"><span style="color:#059669;font-size:11px;">✓</span> Multi-currency support</div>
          <div style="font-size:13px;color:var(--text-sub);display:flex;align-items:center;gap:7px;"><span style="color:#059669;font-size:11px;">✓</span> Bank transfer integration</div>
        </div>
      </div>

      <div style="background:#fff;border:1px solid var(--border);border-radius:16px;padding:24px;box-shadow:var(--shadow-sm);">
        <div style="font-size:22px;margin-bottom:12px;">📅</div>
        <div style="font-size:15px;font-weight:700;color:var(--text);margin-bottom:10px;">Time & Attendance</div>
        <div style="display:flex;flex-direction:column;gap:8px;">
          <div style="font-size:13px;color:var(--text-sub);display:flex;align-items:center;gap:7px;"><span style="color:#059669;font-size:11px;">✓</span> Biometric & mobile punch</div>
          <div style="font-size:13px;color:var(--text-sub);display:flex;align-items:center;gap:7px;"><span style="color:#059669;font-size:11px;">✓</span> Shift scheduling</div>
          <div style="font-size:13px;color:var(--text-sub);display:flex;align-items:center;gap:7px;"><span style="color:#059669;font-size:11px;">✓</span> Geo-fence tracking</div>
          <div style="font-size:13px;color:var(--text-sub);display:flex;align-items:center;gap:7px;"><span style="color:#059669;font-size:11px;">✓</span> Leave management</div>
          <div style="font-size:13px;color:var(--text-sub);display:flex;align-items:center;gap:7px;"><span style="color:#059669;font-size:11px;">✓</span> Holiday calendar</div>
        </div>
      </div>

      <div style="background:#fff;border:1px solid var(--border);border-radius:16px;padding:24px;box-shadow:var(--shadow-sm);">
        <div style="font-size:22px;margin-bottom:12px;">📈</div>
        <div style="font-size:15px;font-weight:700;color:var(--text);margin-bottom:10px;">Performance</div>
        <div style="display:flex;flex-direction:column;gap:8px;">
          <div style="font-size:13px;color:var(--text-sub);display:flex;align-items:center;gap:7px;"><span style="color:#059669;font-size:11px;">✓</span> OKR & goal tracking</div>
          <div style="font-size:13px;color:var(--text-sub);display:flex;align-items:center;gap:7px;"><span style="color:#059669;font-size:11px;">✓</span> 360° feedback cycles</div>
          <div style="font-size:13px;color:var(--text-sub);display:flex;align-items:center;gap:7px;"><span style="color:#059669;font-size:11px;">✓</span> Continuous check-ins</div>
          <div style="font-size:13px;color:var(--text-sub);display:flex;align-items:center;gap:7px;"><span style="color:#059669;font-size:11px;">✓</span> Calibration sessions</div>
          <div style="font-size:13px;color:var(--text-sub);display:flex;align-items:center;gap:7px;"><span style="color:#059669;font-size:11px;">✓</span> Pulse surveys</div>
        </div>
      </div>

      <div style="background:#fff;border:1px solid var(--border);border-radius:16px;padding:24px;box-shadow:var(--shadow-sm);">
        <div style="font-size:22px;margin-bottom:12px;">🎯</div>
        <div style="font-size:15px;font-weight:700;color:var(--text);margin-bottom:10px;">Talent Acquisition</div>
        <div style="display:flex;flex-direction:column;gap:8px;">
          <div style="font-size:13px;color:var(--text-sub);display:flex;align-items:center;gap:7px;"><span style="color:#059669;font-size:11px;">✓</span> Job board publishing</div>
          <div style="font-size:13px;color:var(--text-sub);display:flex;align-items:center;gap:7px;"><span style="color:#059669;font-size:11px;">✓</span> AI resume screening</div>
          <div style="font-size:13px;color:var(--text-sub);display:flex;align-items:center;gap:7px;"><span style="color:#059669;font-size:11px;">✓</span> Interview scheduling</div>
          <div style="font-size:13px;color:var(--text-sub);display:flex;align-items:center;gap:7px;"><span style="color:#059669;font-size:11px;">✓</span> Offer management</div>
          <div style="font-size:13px;color:var(--text-sub);display:flex;align-items:center;gap:7px;"><span style="color:#059669;font-size:11px;">✓</span> Referral programs</div>
        </div>
      </div>

      <!-- AI card — intentionally slightly tinted to highlight Beta status -->
      <div style="background:var(--p50);border:1px solid var(--p200);border-radius:16px;padding:24px;box-shadow:var(--shadow-sm);">
        <div style="font-size:22px;margin-bottom:12px;">🤖</div>
        <div style="font-size:15px;font-weight:700;color:var(--text);margin-bottom:10px;">AI & Analytics <span style="font-size:10px;background:#FFFBEB;color:#D97706;border:1px solid #FDE68A;padding:2px 8px;border-radius:20px;margin-left:6px;font-weight:700;">Beta</span></div>
        <div style="display:flex;flex-direction:column;gap:8px;">
          <div style="font-size:13px;color:var(--text-sub);display:flex;align-items:center;gap:7px;"><span style="color:var(--p600);font-size:11px;">✓</span> AI HR chatbot</div>
          <div style="font-size:13px;color:var(--text-sub);display:flex;align-items:center;gap:7px;"><span style="color:var(--p600);font-size:11px;">✓</span> Attrition prediction</div>
          <div style="font-size:13px;color:var(--text-sub);display:flex;align-items:center;gap:7px;"><span style="color:var(--p600);font-size:11px;">✓</span> Smart dashboards</div>
          <div style="font-size:13px;color:var(--text-sub);display:flex;align-items:center;gap:7px;"><span style="color:var(--p600);font-size:11px;">✓</span> Custom report builder</div>
          <div style="font-size:13px;color:var(--text-sub);display:flex;align-items:center;gap:7px;"><span style="color:var(--p600);font-size:11px;">✓</span> Workforce forecasting</div>
        </div>
      </div>

    </div>
  </div>
</section>


<!-- ============================================================
     CTA
============================================================ -->
<section style="padding:80px 0;">
  <div class="cta-band">
    <h2 class="cta-band__h2">See Every Feature<br>Live in 30 Minutes</h2>
    <p class="cta-band__sub">Book a personalized demo and our team will walk you through the exact features that matter to your business.</p>
    <div class="cta-band__actions">
      <a href="#" class="btn btn-white btn-lg">Book a Free Demo</a>
      <a href="#" class="btn btn-outline btn-lg">Start Free Trial</a>
    </div>
  </div>
</section>

<app-peopleflow-footer></app-peopleflow-footer>